import Index from '../components/Index/Index';
import UsersListContainer from '../containers/UsersListContainer';
import UserDetailContainer from '../containers/UserDetailContainer';

export default {
    path: '/users',
    component: Index,
    title: 'user_list',
    description: 'user_detail',
    icon: './icons/general.svg',
    routes: [{
        path: '/users/new',
        component: UserDetailContainer,
        exact: true,
        title: 'new_user',
        description: 'new_user_detail'
    }, {
        path: '/users/:id',
        component: UserDetailContainer,
        exact: true
    }, {
        path: '/users',
        component: UsersListContainer,
        exact: true
    }],
    permission: { index: 0, value: 10 }
};
